/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ModalPopupMessage from '../components/modal/ModalPopupMessage';
import './StepBuySale.css';

function StepBuySale(props) {
  const navigate = useNavigate();
  const [navigate_url, setNavigate_url] = useState('');
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  async function security_protection(mode) {
    if (mode === 'seller' || mode === 'buyer') {
      if (props.permitdata.token === '' || props.permitdata.token === '-') {
        setModal_popup({
          modaltype: 'modal-signup',
          headers: 'กรุณาสมัครสมาชิก',
          message:
            'การซื้อขายสินค้าบน แพล๊ตฟอร์ม มียานั้น ผู้ใช้งานจะต้องลงทะเบียนก่อนเริ่มทำการซื้อขาย',
          enable: true,
        });
      } else {
        if (mode === 'seller') {
          setNavigate_url('/myshop/seller/jobtodo');
        } else {
          setNavigate_url('/marketplace?category=รวมสินค้า');
        }
      }
    }
  }

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
    setNavigate_url('/');
  }

  useEffect(() => {
    if (navigate_url !== '') {
      navigate(navigate_url);
    }
  }, [navigate_url]);

  const steps = [props.step1, props.step2, props.step3, props.step4];

  return (
    <div className='col-xl-12'>
      <hr className='text-center max-width-450' />
      <h6 className='text-center font-weight-bold font-th'>{props.stepname}</h6>

      <div className='stepbuysale mb-3'>
        {steps.map((step, index) => {
          const content = (
            <>
              <span className='step-number'>{index + 1}</span>
              <div className='step-icon'>
                <i className={step.iconclass}></i>
              </div>
              <div className='step-title'>{step.header}</div>
              <div className='step-desc'>{step.text}</div>
            </>
          );

          // Render as a link when a link is provided, otherwise as a non-clickable card
          if (step.link) {
            return (
              <a
                key={index}
                href={step.link || '#'}
                target='_blank'
                rel='noopener noreferrer'
                className='step-card text-decoration-none text-reset'
              >
                {content}
              </a>
            );
          }

          return (
            <div key={index} className='step-card text-decoration-none text-reset'>
              {content}
            </div>
          );
        })}
      </div>

      <div className='action-row'>
        <Link
          to='#'
          className='btn bg-green transition-3d-hover rounded-lg py-2 px-3 font-size-16 font-th text-white mb-6 mx-auto d-block btn-fixedwidth-160'
          onClick={() => {
            security_protection(props.mode);
          }}
        >
          {props.button.text}
        </Link>
      </div>

      <ModalPopupMessage
        callback_general={showDialogCallback_General}
        callback_confirm={showDialogCallback_Confirm}
        options={modal_popup}
      />
    </div>
  );
}

export default StepBuySale;
